export default "__VITE_ASSET__1cfe86c0__"